import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #SEARCH-FORM
\*------------------------------------ */
[popover] {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/**
 * Search form
 * 1) Inline form consisting of an form input and button used for search functionality
 */
.cat-c-search-form {
  width: 100%;
  position: relative;
  display: block;
  --cat-dropdown-checkbox-background: var(--cat-theme-color-background-default);
}
.cat-c-search-form.cat-is-overlay {
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  z-index: var(--cat-z-index-400);
  height: 100%;
  background: var(--cat-theme-color-background-default);
  --cat-dropdown-panel-border-block-start-left-radius: 0;
  --cat-dropdown-panel-border-block-start-right-radius: 0;
  --cat-dropdown-panel-border-block-end-right-radius: 0;
  --cat-dropdown-panel-border-block-end-left-radius: 0;
}

/**
 * Search Mobile form
 */
.cat-c-search-form--mobile {
  display: none;
  inset: 0;
  background: var(--cat-theme-color-background-default);
  --cat-dropdown-panel-border-block-start-left-radius: 0;
  --cat-dropdown-panel-border-block-start-right-radius: 0;
  --cat-dropdown-panel-border-block-end-right-radius: 0;
  --cat-dropdown-panel-border-block-end-left-radius: 0;
}
.cat-c-search-form--mobile.cat-is-overlay {
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  z-index: var(--cat-z-index-400);
  height: 100%;
  background: var(--cat-theme-color-background-default);
}

/**
 * hides the span which is specifically written for accessibility
 */
.cat-is-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Search form disabled
 */
.cat-is-disabled {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-is-disabled .cat-c-search-form__icon-after {
  display: none;
}
.cat-is-disabled .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-x-small);
}

/**
 * Search form label
 */
.cat-c-search-form__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-search-form__typeahead-wrapper {
  display: flex;
  position: relative;
  flex-basis: 100%;
}
.cat-is-overlay .cat-c-search-form__typeahead-wrapper {
  position: static;
}

/**
 * Search form typeahead
 * 1) The wrapper that contains the input and dropdown panel
 */
.cat-c-search-form__typeahead {
  position: relative;
  flex-basis: 100%;
}
.cat-is-overlay .cat-c-search-form__typeahead {
  position: static;
}
.cat-c-search-form__typeahead .cat-is-active {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Search form icons
 * 1) Icons positioned absolutely in the input
 */
.cat-c-search-form__icon-container {
  position: absolute;
  inset-block: 50% 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: var(--cat-space-x-small);
  inset-inline-end: var(--cat-space-medium);
  height: calc(var(--size-base-unit) * 3);
  --cat-theme-color-button-icon-default-background-active: transparent;
}
.cat-c-search-form__icon-container .cat-c-search-form-icon--separator {
  width: calc(var(--size-base-unit) * 0.125);
  height: calc(var(--size-base-unit) * 2);
  background-color: var(--cat-theme-color-border-default);
}
.cat-c-search-form--medium .cat-c-search-form__icon-container {
  inset-inline-end: var(--cat-space-small);
}
.cat-c-search-form--small .cat-c-search-form__icon-container {
  inset-block-end: var(--cat-space-3x-small);
  inset-inline-end: var(--cat-space-x-small);
}
.cat-is-overlay .cat-c-search-form__icon-container {
  inset-block-end: var(--cat-space-x-large);
  inset-inline-end: var(--cat-space-2x-large);
}

/**
 * Search form icons before input text
 */
.cat-is-overlay .cat-c-search-form__icon-before {
  inset-inline-start: calc(var(--size-base-unit) * 10.5);
}

.cat-c-search-form__error-icon {
  inset-inline-end: var(--cat-space-4x-large);
}

.cat-c-search-form__warning-icon {
  inset-inline-end: var(--cat-space-4x-large);
}

/**
 * Search form clear button
 */
.cat-c-search-form__clear-button {
  cursor: pointer;
  margin-inline-end: calc(-1 * var(--cat-space-x-small));
  --cat-button-ghost-hover-background: transparent;
}
.cat-c-search-form__clear-button .cat-icon {
  color: var(--cat-theme-color-content-default);
}
.cat-c-search-form__clear-button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-search-form--large .cat-c-search-form__clear-button {
  margin-inline-end: calc(-1 * var(--cat-space-x-small));
}
.cat-is-overlay .cat-c-search-form__clear-button {
  margin-inline-end: 0;
  --cat-button-padding: calc(var(--size-base-unit) * 1.125) 0;
}

/**
 * Search form body
 * 1) The container for the input and button
 */
.cat-c-search-form__body {
  display: flex;
  align-items: stretch;
  transition: outline var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Search form body within search form with button variant
   */
  /**
   * Search form body within search form with button variant in mobile overlay
   */
  /**
   * Search form body within error state of with button variant
   */
}
.cat-is-overlay .cat-c-search-form__body {
  background-color: var(--cat-theme-color-background-xstrong);
  padding: var(--cat-space-medium);
  position: relative;
}
.cat-c-search-form--with-button .cat-c-search-form__body {
  outline: 1px solid transparent;
  outline-offset: -1px;
  border-radius: var(--cat-border-radius-md);
  transition: outline var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-search-form.cat-is-overlay .cat-c-search-form__body {
  border-radius: 0;
}
.cat-c-search-form--with-button.cat-is-error:not(.cat-is-overlay) .cat-c-search-form__body {
  background-color: var(--cat-theme-color-background-default);
}

/**
 * Search form input
 */
.cat-c-search-form__input {
  display: block;
  appearance: none;
  width: 100%;
  border-width: var(--cat-theme-border-width);
  border-style: solid;
  border-color: var(--cat-theme-color-form-border);
  border-radius: var(--cat-theme-border-radius);
  outline: var(--cat-input-field--outline, none);
  outline-offset: var(--cat-input-field--outline-offset, 0);
  padding: var(--cat-space-medium);
  padding-inline-start: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  /** 
    * TODO: this line-height & font-size should be set cat-theme-typography-body 
    * currently cat-theme-typography-body is used many placed. So it got overridden directly here
    **/
  line-height: var(--cat-line-height-default, var(--cat-line-height-24));
  font-size: var(--cat-font-size-default, var(--cat-font-size-16));
  color: var(--cat-theme-color-content-default);
  background-color: var(--cat-theme-color-form-background);
  box-shadow: var(--cat-input-box-shadow);
  transition: border-color var(--cat-anim-fade-quick) var(--cat-anim-ease), background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), box-shadow var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
     * Hover styles for default input elements
     */
  /**
     * Focus & active styles for default input elements
     */
  /**
     * When the input is clicked on
     */
  /**
     * Disabled styles for default input elements
     */
  /**
     * Focus visible for input fields
     */
  /**
     * Placeholder styles for input fields
     */
  /**
     * Error textarea field
     */
  /**
     * Successful textarea field
     */
  /**
   * Hover styles for error input elements
   */
  /**
   * Search form input that has button
   * 1) Allow hover state on the search form body override default text input states
   */
  /**
    adding color for error state border 
  */
}
.cat-c-search-form__input:hover:not(:disabled) {
  color: var(--cat-theme-color-content-default-hover);
  border-color: var(--cat-theme-color-form-border-hover);
  background-color: var(--cat-theme-color-form-background-hover);
  /**
     * Hover styles for input with error state
     */
}
.cat-is-error .cat-c-search-form__input:hover:not(:disabled) {
  border-color: var(--cat-theme-color-border-utility-error-hover);
  background-color: var(--cat-theme-color-background-default);
}
.cat-is-error .cat-c-search-form__input:hover:not(:disabled) ~ .cat-icon, .cat-is-error .cat-c-search-form__input:hover:not(:disabled)::placeholder {
  color: var(--cat-theme-color-content-default);
}
.cat-c-search-form__input:focus:not(:disabled, [readonly]) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  color: var(--cat-theme-color-content-default-hover);
  border-color: var(--cat-theme-color-form-border-focus);
  /**
     * Focus styles for label & placeholder
     */
  /**
     * Focus styles for input with error state
     */
}
.cat-c-search-form__input:focus:not(:disabled, [readonly]) ~ .cat-c-input-field__label,
.cat-c-search-form__input:focus:not(:disabled, [readonly]) ~ .cat-icon {
  color: var(--cat-theme-color-content-default-hover);
}
.cat-c-search-form__input:focus:not(:disabled, [readonly])::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-is-error .cat-c-search-form__input:focus:not(:disabled, [readonly]) ~ .cat-icon, .cat-is-error .cat-c-search-form__input:focus:not(:disabled, [readonly])::placeholder {
  color: var(--cat-theme-color-content-default);
}
.cat-c-search-form__input:active:not(:disabled) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-search-form__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  /**
     * Disabled text colors
     */
  /**
     * Disabled text colors
     */
}
.cat-c-search-form__input:disabled ~ .cat-c-input-field__label, .cat-c-search-form__input:disabled:hover ~ .cat-c-input-field__label, .cat-c-search-form__input:disabled::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-error .cat-c-search-form__input:disabled ~ .cat-c-input-field__label, .cat-is-error .cat-c-search-form__input:disabled:hover ~ .cat-c-input-field__label, .cat-is-error .cat-c-search-form__input:disabled::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-search-form__input:disabled ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label, .cat-c-search-form__input:disabled:hover ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-error .cat-c-search-form__input:disabled ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label, .cat-is-error .cat-c-search-form__input:disabled:hover ~ .cat-c-input-field__label-wrapper .cat-c-input-field__label {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-search-form__input:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-search-form__input::placeholder {
  color: var(--cat-theme-color-content-subtle);
}
.cat-is-error .cat-c-search-form__input {
  border-color: var(--cat-theme-color-border-utility-error);
}
.cat-is-error .cat-c-search-form__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
}
.cat-is-success .cat-c-search-form__input {
  border-color: var(--cat-theme-color-border-utility-success);
  background-color: var(--cat-theme-color-background-utility-success);
}
.cat-is-success .cat-c-search-form__input:hover, .cat-is-success .cat-c-search-form__input:focus {
  background-color: var(--cat-theme-color-background-utility-success);
}
.cat-is-success .cat-c-search-form__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
}
.cat-c-search-form__input {
  width: 100%;
  height: calc(var(--size-base-unit) * 7);
  padding-inline: var(--cat-space-medium) calc(var(--size-base-unit) * 5.625);
  padding-block: var(--cat-space-x-small);
}
.cat-c-search-form__input:disabled {
  font-weight: var(--cat-font-weight-regular);
}
.cat-c-search-form__input:hover:not(:disabled) {
  background-color: var(--cat-theme-color-background-default-hover);
}
.cat-is-error .cat-c-search-form__input:hover:not(:disabled) {
  border-color: var(--cat-theme-color-border-utility-error);
  background-color: var(--cat-theme-color-background-default-hover);
}
.cat-is-overlay .cat-c-search-form__input:focus:not(:disabled) {
  box-shadow: none;
}
.cat-c-search-form--with-button:not(.cat-is-overlay) .cat-c-search-form__input {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.cat-is-error .cat-c-search-form__input:not(:disabled) {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
}
.cat-c-search-form--with-button .cat-c-search-form__input {
  padding-inline-start: calc(var(--size-base-unit) * 2);
}
.cat-c-search-form--with-button .cat-c-search-form__input:placeholder-shown {
  padding-inline-start: calc(var(--size-base-unit) * 2);
}
.cat-c-search-form.cat-c-search-form--with-button:not(.cat-is-disabled) .cat-c-search-form__body:hover:not(:focus, :active, :disabled) .cat-c-search-form__input {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.cat-c-search-form--medium .cat-c-search-form__input {
  height: calc(var(--size-base-unit) * 5);
  padding-inline-start: var(--cat-space-small);
}
.cat-c-search-form--small .cat-c-search-form__input {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  padding-block: var(--cat-space-x-small);
  padding-inline-start: var(--cat-space-x-small);
  height: calc(var(--size-base-unit) * 4);
  font-weight: var(--cat-font-weight-regular);
}
.cat-is-active.cat-is-dirty .cat-c-search-form__input:not(:disabled) {
  background-color: var(--cat-theme-color-form-background-hover);
}
.cat-is-overlay .cat-c-search-form__input {
  padding-block: var(--cat-space-x-small);
  height: calc(var(--size-base-unit) * 5);
}
.cat-is-error .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-7x-large);
}
.cat-is-warning .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-7x-large);
}
.cat-is-dirty .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-7x-large);
}
.cat-is-error.cat-is-dirty .cat-c-search-form__input {
  padding-inline-end: calc(var(--size-base-unit) * 12);
}
.cat-is-warning.cat-is-dirty .cat-c-search-form__input {
  padding-inline-end: calc(var(--size-base-unit) * 12);
}
.cat-c-search-form--with-button.cat-is-error .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-3x-large);
}
.cat-c-search-form--with-button.cat-is-warning .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-3x-large);
}
.cat-c-search-form--with-button.cat-is-dirty .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-3x-large);
}
.cat-c-search-form--with-button.cat-is-error.cat-is-dirty .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-6x-large);
}
.cat-c-search-form--with-button.cat-is-warning.cat-is-dirty .cat-c-search-form__input {
  padding-inline-end: var(--cat-space-6x-large);
}

/**
 * Search form submit button
 * 1) Moves the focus ring to the inside of the button to prevent overlay issues
 */
.cat-c-search-form__submit-button {
  --cat-button-border-start-start-radius: 0;
  --cat-button-border-end-start-radius: 0;
  --cat-theme-offset-focus-ring: 2px; /* 1 */
  --cat-button-border-block-start-left-radius: 0;
  --cat-button-border-block-end-left-radius: 0;
  --cat-theme-button-height: 100%;
  white-space: nowrap;
}
.cat-c-search-form__submit-button .cat-c-search-form__submit-button-icon {
  color: var(--cat-theme-color-content-default);
}
.cat-is-overlay .cat-c-search-form__submit-button {
  display: none;
}

/**
 * Search form dropdown
 * 1) The dropdown panel that contains the slotted items
 * 2) Square off the dropdown panel on top left and right
 * 2) Make the dropdown panel border transparent
 */
.cat-c-search-form__dropdown-panel {
  display: block;
  height: 0;
  overflow: hidden;
  position: absolute;
  inset-block-start: 100%;
  width: 100%;
  z-index: var(--cat-z-index-400);
  min-width: var(--cat-c-search-form-dropdown-panel--min-width, auto);
  max-width: var(--cat-c-search-form-dropdown-panel--max-width, auto);
  --cat-dropdown-panel-border-start-start-radius: 0; /* 2 */
  --cat-dropdown-panel-border-start-end-radius: 0; /* 2 */
  --cat-dropdown-panel-border-color: var(--cat-theme-color-border-default); /* 3 */
  /**
   * When the search form is active, show the dropdown panel
   */
  /**
   * Search form mobile dropdown panel
   */
  /**
   * Dropdown panel positioned to the top of the input
   */
}
.cat-is-active .cat-c-search-form__dropdown-panel {
  overflow: visible;
  height: auto;
}
.cat-is-overlay .cat-c-search-form__dropdown-panel {
  position: absolute;
  --cat-panel-box-shadow: none;
  width: 100% !important;
  height: calc(100svh - var(--size-base-unit) * 9);
  overflow-y: auto;
  z-index: var(--cat-z-index-400);
  inset-block-start: var(--cat-space-7x-large) !important;
  inset-inline-start: 0;
  --cat-dropdown-panel-border-color: var(--cat-color-transparent-transparent);
  --cat-dropdown-panel-border-start-end-radius: 0;
  --cat-dropdown-panel-border-end-start-radius: 0;
  --cat-dropdown-panel-border-end-end-radius: 0;
  transform: translate(0) !important;
  /**
   * When the search form is active, show the dropdown panel
   */
}
.cat-is-active .cat-is-overlay .cat-c-search-form__dropdown-panel {
  visibility: visible;
}
.cat-c-search-form--top .cat-c-search-form__dropdown-panel {
  inset-block-start: unset;
  inset-block-end: 100%;
}
.cat-c-search-form--bottom .cat-c-search-form__dropdown-panel {
  inset-block-start: 100%;
}

/**
 * Search form back button for mobile variant
 */
.cat-c-search-form__back-button {
  appearance: none;
  outline: none;
  border: none;
  margin-inline-end: var(--cat-space-x-small);
  display: none;
  align-self: center;
}

.cat-c-search-form__field-note .cat-is-error {
  color: var(--cat-theme-color-content-utility-error);
}

/**
 * Second list for accessibility (in the shadow root)
 * 1) Visually hide this list so that it reads out properly for screen readers but
 * doesn't show any items since the panel items do that work.
 */
.cat-c-search-form__accessibility-list {
  display: none;
}
.cat-c-search-form.cat-is-active .cat-c-search-form__accessibility-list {
  display: block;
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  /* 1 */
}

/**
 * Apply  loaders  style
 */
.cat-c-search-form--loader {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-3x-small);
}

.cat-c-search-form-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3.5);
  position: relative;
}
.cat-c-search-form-loader .cat-c-search-form__icon-loader {
  position: absolute;
  inset-inline-end: var(--cat-space-medium);
  inset-block-end: calc(var(--size-base-unit) * 1.25);
}
.cat-c-search-form--medium .cat-c-search-form-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
}
.cat-c-search-form--small .cat-c-search-form-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}

/**
 * To hide custom slot on overlay view
 */
.cat-is-overlay slot[name=custom] {
  display: none;
}
`;
       